export const mockData = {
  // Mock response for login
  auth: {
    login: {
      api_key: "mock-admin-token-12345",
    }
  },

  // Mock response for dashboard stats
  dashboard: {
    statistics: {
      totalUsers: 1250,
      totalLoans: 450,
      totalDocuments: 890
    },
    demographics: {
      ageDistribution: [
        { age_range: 20, count: "150" },
        { age_range: 30, count: "450" },
        { age_range: 40, count: "350" },
        { age_range: 50, count: "200" },
        { age_range: 60, count: "100" }
      ],
      genderDistribution: [
        { gender: "Male", count: "700" },
        { gender: "Female", count: "550" }
      ],
      employmentDistribution: [
        { employment_status: "Employed in Private or Semi-Govt Sector Full-Time", count: "400" },
        { employment_status: "Employed in Private or Semi-Govt Sector Part-Time", count: "150" },
        { employment_status: "Government Employee", count: "200" },
        { employment_status: "Freelancer/Gig Worker", count: "150" },
        { employment_status: "Student", count: "100" },
        { employment_status: "Retired", count: "50" }
      ]
    },
    recentLoans: [
      {
        id: 1,
        user_id: "USR001",
        first_name: "John",
        borrow_amount: 5000,
        application_sources: ["Jamiya", "Bank"],
        loan_purposes: ["Debt consolidation", "Medical expenses"],
        loan_status: "Active",
        created_at: "2024-03-15T10:30:00Z"
      },
      {
        id: 2,
        user_id: "USR002",
        first_name: "Sarah",
        borrow_amount: 3000,
        application_sources: ["Bank"],
        loan_purposes: ["Home renovation", "Home furniture"],
        loan_status: "Paid",
        created_at: "2024-03-14T15:45:00Z"
      },
      {
        id: 3,
        user_id: "USR003",
        first_name: "Michael",
        borrow_amount: 7500,
        application_sources: ["Financing company"],
        loan_purposes: ["Business investment"],
        loan_status: "Pending",
        created_at: "2024-03-14T09:15:00Z"
      }
    ],
    recentDocuments: [
      {
        document_id: 1,
        user_id: "USR001",
        file_name: "Income_Statement_2024.pdf",
        first_name: "John Doe",
        created_at: "2024-03-15T11:30:00Z",
        document_type: "Income Statement"
      },
      {
        document_id: 2,
        user_id: "USR002",
        file_name: "Bank_Statement_Q1.pdf",
        first_name: "Sarah Smith",
        created_at: "2024-03-14T16:45:00Z",
        document_type: "Bank Statement"
      },
      {
        document_id: 3,
        user_id: "USR003",
        file_name: "ID_Verification.pdf",
        first_name: "Michael Brown",
        created_at: "2024-03-14T09:20:00Z",
        document_type: "ID Proof"
      }
    ]
  },

  // Mock response for users list
  users: {
    users: [
      {
        id: 1,
        user_id: "USR001",
        first_name: "John",
        email: "john.doe@example.com",
        mobile_number: "+1234567890",
        age: 32,
        gender: "Male",
        employment_status: "Employed in Private or Semi-Govt Sector Full-Time",
        average_monthly_income: 5000,
        income_sources: [
          "Salary from employment",
          "Rental income",
          "Side hustle"
        ],
        created_at: "2024-02-15T08:30:00Z"
      },
      {
        id: 2,
        user_id: "USR002",
        first_name: "Jane",
        email: "jane.smith@example.com",
        mobile_number: "+1987654321",
        age: 28,
        gender: "Female",
        employment_status: "Government Employee",
        average_monthly_income: 6500,
        income_sources: [
          "Salary from employment",
          "Freelance or gig-work income"
        ],
        created_at: "2024-02-20T14:45:00Z"
      }
    ],
    pagination: {
      total: 150,  // Total number of users
      page: 1,     // Current page
      pages: 15    // Total number of pages (assuming limit of 10)
    }
  },

  // Mock response for user details
  userDetail: {
    user: {
      user_id: "USR001",
      first_name: "John",
      email: "john.doe@example.com",
      mobile_number: "+1234567890",
      age: 32,
      gender: "Male",
      employment_status: "Employed in Private or Semi-Govt Sector Full-Time",
      average_monthly_income: 5000,
      income_sources: [
        "Salary from employment",
        "Side hustle",
        "Rental income"
      ],
      created_at: "2024-02-15T08:30:00Z"
    },
    loans: [
      {
        id: 1,
        user_id: "USR001",
        borrow_amount: 10500,
        application_sources: ["Jamiya", "Bank"],
        loan_purposes: ["Debt consolidation", "Medical expenses"],
        loan_status: "Active",
        created_at: "2024-03-01T10:00:00Z"
      },
      {
        id: 2,
        user_id: "USR001",
        borrow_amount: 3000,
        application_sources: ["Bank"],
        loan_purposes: ["Home renovation", "Home furniture"],
        loan_status: "Paid",
        created_at: "2024-01-15T09:30:00Z"
      }
    ],
    documents: [
      {
        document_id: 1,
        user_id: "USR001",
        document_type: "ID Proof",
        file_name: "id-proof.pdf",
        created_at: "2024-02-15T08:35:00Z"
      },
      {
        document_id: 2,
        user_id: "USR001",
        document_type: "Income Statement",
        file_name: "income.pdf",
        created_at: "2024-02-15T08:40:00Z"
      }
    ]
  }
}; 